import React from 'react';
import { Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';

const style = {
  height: '50px',
};

const GPICreditCardFields = () => {
  return (
    <>
      <Grid item xs={12} sm={3}>
        <TextField
          label='Card Number'
          name='ccnumber'
          variant='outlined'
          style={{ width: 'auto' }}
          required
          fullWidth
          InputLabelProps={{ shrink: true }}
          InputProps={{
            inputComponent: () => {
              return <div style={style} id='card-number-gpi'></div>;
            },
          }}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label='Expiration Date'
          name='ccexp'
          variant='outlined'
          style={{ width: 'auto' }}
          required
          fullWidth
          InputLabelProps={{ shrink: true }}
          InputProps={{
            inputComponent: () => {
              return <div style={style} id='card-expiration-gpi'></div>;
            },
          }}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label='CVC Code'
          name='cvc'
          variant='outlined'
          style={{ width: 'auto' }}
          required
          fullWidth
          InputLabelProps={{ shrink: true }}
          InputProps={{
            inputComponent: () => {
              return <div style={style} id='card-cvv-gpi'></div>;
            },
          }}
        />
      </Grid>
    </>
  );
};

export default React.memo(GPICreditCardFields);
